import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/commons/generic.service";
import { environment } from "environments/environment";
import { CertificadoResult } from "models/certificado";
import { CertificadoTemplateDTO } from "models/certificado-template";
import { CertificadoValidacaoDTO } from "models/certificado-validacao";
import { CertificadosEmitidosFiltro } from "models/filtro-certificados-emitidos";
import { FiltroPaginado } from "models/filtro-paginacao";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class CertificadoService extends GenericService {
    private relativePath = "v1/certificados";

    constructor(http: HttpClient) {
        super(http);
    }

    buscarCertificadosEmitidos(filtro: CertificadosEmitidosFiltro): Observable<any> {
        return this.postMethod(filtro, this.relativePath + "/buscar-certificados-emitidos");
    }

    buscarCertificadosAEmitir(idEstudante: number, filtro: FiltroPaginado): Observable<any> {
        const params = new HttpParams().set("pagina", filtro.pagina).set("tamanho", filtro.tamanho);

        return this.getMethod(this.relativePath + "/buscar-certificados-a-emitir/" + idEstudante, params);
    }

    emitirCertificado(id: number): Observable<any> {
        return this.postMethod(id, this.relativePath + "/emitir-certificado");
    }

    getTemplateCertificado(): Observable<string> {
        return this.getMethod(this.relativePath + "/template");
    }

    obterCertificado(id: number): Observable<CertificadoTemplateDTO> {
        return this.getMethod<CertificadoTemplateDTO>(this.relativePath + `/${id}`);
    }

    obterImagemObjectURL(urlOuId: string | number, withCredentials: boolean = false): Observable<string> {
        return this.obterImagem(urlOuId, withCredentials).pipe(map((blob: Blob) => URL.createObjectURL(blob)));
    }

    obterImagem(urlOuId: string | number, withCredentials: boolean = false): Observable<Blob> {
        const id = typeof urlOuId === "number" ? urlOuId : this.extrairIdImagem(urlOuId);
        const finalUrl = this.resolverUrlImagens(id);

        const options: any = {
            responseType: "blob" as "json",
            withCredentials, // use true se o backend depender de cookie; p/ JWT em header, normalmente false
            headers: this.getAuthHeaders(),
        };

        return this.http.get(finalUrl, options) as any as Observable<Blob>;
    }

    validar(id: number): Observable<CertificadoValidacaoDTO> {
        return this.getMethod<CertificadoValidacaoDTO>(this.relativePath + "/validar/" + id);
    }

    private getAuthHeaders(): HttpHeaders {
        const token = localStorage.getItem("token") || "";
        return new HttpHeaders({
            Authorization: `Bearer ${token}`,
        });
    }

    private extrairIdImagem(url: string): number {
        if (!url) {
            return NaN;
        }
        const m = url.match(/\/imagens\/(\d+)(?:$|\?)/);
        return m ? +m[1] : NaN;
    }

    private resolverUrlImagens(id: number): string {
        return `${environment.url}imagens/${id}`;
    }

    private buildParams(obj: { [k: string]: any }) {
        let p = new (window as any).HttpParams();
        Object.keys(obj || {}).forEach(k => {
            if (obj[k] !== undefined && obj[k] !== null) {
                p = p.set(k, String(obj[k]));
            }
        });
        return p;
    }
}
